import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { map, catchError, tap, retry } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';
import * as io from 'socket.io-client';
import * as moment from 'moment';
import { EfoEgiService } from './egi.service';
import { SettingsService } from '../../core/services/settings.service';
import { AccessService } from '../../core/services/access.service';
import { LodashService } from './lodash.service';
import { ElevationService } from './elevation.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CbrService {
  // private socketUrl = 'http://socket1.carbrewer.com:3002';
  private socketUrl = 'http://socket.epiphanex.com:5000';
  private socket;

  private selectedDealer$: BehaviorSubject<any> = new BehaviorSubject(null);
  public readonly selectedDealer: Observable<any> =
    this.selectedDealer$.asObservable();
  public dealer: any = {};

  private userSubscription$;
  constructor(
    private appSettings: SettingsService,
    private efoEgi: EfoEgiService,
    private _sanitizer: DomSanitizer,
    private accessApi: AccessService,
    private efoLd: LodashService,
    private efoElevation: ElevationService,
    private http: HttpClient,
  ) {
    //this.brandMarketShare();

    this.userSubscription$ = this.accessApi.mee.subscribe((user) => {
      var settings = this.appSettings.get();
      if (_.has(settings, 'dealer_uuid') && settings.dealer_uuid.length == 36) {
        this.getAllDealerByUuid2(settings.dealer_uuid).subscribe((dealer) => {
          this.selectedDealer$.next(dealer);
        });
      }
    });

    this.selectedDealer$.subscribe((dealer) => {
      this.dealer = dealer;
      if (_.has(dealer, 'account_num')) {
      }
    });
  }

  selectDealer(dealer): void {
    const { dealer_uuid } = dealer;
    this.appSettings.set({ dealer_uuid });
    this.selectedDealer$.next(dealer);
  }
  get(url, params = {}): Observable<any> {
    const queryString =
      url.indexOf('?') == -1 && !_.isEmpty(params)
        ? '?' + new URLSearchParams(params).toString()
        : '';
    return this.http.get(`${environment.nestCbrApiUrl}${url}${queryString}`);
  }
  post(url, params = {}): Observable<any> {
    return this.http.post(`${environment.nestCbrApiUrl}${url}`, params);
  }
  put(url, params = {}): Observable<any> {
    return this.http.put(`${environment.nestCbrApiUrl}${url}`, params);
  }
  delete(url, params = {}): Observable<any> {
    return this.http.delete(`${environment.nestCbrApiUrl}${url}`, params);
  }

  getWebCrawl(cbr_uuid): Observable<any> {
    return this.get('/inventory/getWebCrawl', { cbr_uuid });
  }
  getWizardAssessments(start_date?, end_date?): Observable<any> {
    return this.get('/inventory/getWizardAssessments', {
      start_date,
      end_date,
    });
  }
  getWizardAssessment(cbr_uuid): Observable<any> {
    return this.get('/inventory/getWizardAssessment', { cbr_uuid });
  }
  updateAssessment(cbr_uuid, data): Observable<any> {
    return this.put(`/inventory/updateAssessment/${cbr_uuid}`, data);
  }

  allDealers: any = [];
  loadAllDealersMem(reload_flag?: boolean): Observable<any> {
    reload_flag = _.isUndefined(reload_flag) ? false : reload_flag;
    if (!_.isEmpty(this.allDealers) && !reload_flag) {
      return of(this.allDealers).pipe();
    } else {
      return this.efoEgi
        .getDataCbr('/inventory/getAllDealersMem', {
          cols: 'dealer_uuid,name,state,brands,latitude,longitude,address1,city,zip,phone,web_crawl.provider,web_crawl.new_count,web_crawl.used_count,proposal.price_sales,facebook,hubspot,edifice,growpodium',
        })
        .pipe(
          map((rs) => {
            this.allDealers = rs;
            return rs;
          }),
        );
    }
  }

  filterAllDealersMem(filters?: {}): Observable<any> {
    return this.loadAllDealersMem().pipe(
      switchMap((rs) => {
        var results = _.isUndefined(filters) ? rs : _.filter(rs, filters);
        return of(results).pipe();
      }),
    );
  }
  getAllDealersMem(options?: {}): Observable<any> {
    //return this.efoEgi.getDataCbr('/inventory/getAllDealersMem', {cols:'dealer_uuid,name,state,brands,website,latitude,longitude,address1,city,zip,phone,web_crawl.provider,web_crawl.new_count,web_crawl.used_count,proposal.price_sales,proposal.population_15miles',limit:30000})
    return this.efoEgi.getDataCbr('/inventory/getAllDealersMem', options).pipe(
      map((rs) => {
        return rs;
      }),
    );
  }

  getAllDealers(options?: {}): Observable<any> {
    return this.http.post(
      `${environment.nestElevationApiUrl}/inventory/allDealers`,
      options,
    );
  }

  getAllDealersActiveAccounts(options?): Observable<any> {
    return this.efoEgi.getData('/omt/getActiveAccounts', {}).pipe(
      switchMap((rs) => {
        return this.getAllDealers({
          filters: {
            cbr_uuid: _.map(rs, 'cbr_uuid').join(','),
          },
        });
      }),
    );
  }

  getAllDealersDt(options?): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getAllDealersDt', options);
  }

  getWebCounts(dealer_uuid, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 1 : limit;
    return this.efoEgi.getDataCbr('/inventory/getAllDealerWebCounts', {
      dealer_uuid: dealer_uuid,
      limit,
    });
  }
  findWebProvider(dealer_uuid, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 1 : limit;
    return this.efoEgi.getDataCbr('/inventory/findDealerWebProvider', {
      dealer_uuid: dealer_uuid,
      limit,
    });
  }

  setWebProvider(dealer_uuid, provider): Observable<any> {
    return this.updateAllDealer(dealer_uuid, {
      web_crawl: { provider: provider },
    });
  }
  setWebsite(dealer_uuid, website): Observable<any> {
    return this.updateAllDealer(dealer_uuid, { url: website });
  }
  updateWebcrawler(dealer_uuid, website, provider, options?): Observable<any> {
    options = _.isUndefined(options) ? {} : options;
    return this.updateAllDealer(dealer_uuid, {
      url: website,
      web_crawl: _.extend({ provider: provider }, options),
    }).pipe(
      switchMap((rs) => {
        if (provider == 'dealerinspire2020') {
          return this.findDealerInspirePostData(dealer_uuid).pipe(
            switchMap((rs) => {
              return this.getWebCounts(dealer_uuid);
            }),
          );
        } else if (provider == 'FordDirect2020FordDirect2020') {
          return this.findFordDirectPostData(dealer_uuid).pipe(
            switchMap((rs) => {
              return this.getWebCounts(dealer_uuid);
            }),
          );
        } else {
          return this.getWebCounts(dealer_uuid);
        }
      }),
    );
  }
  updateAllDealer(dealer_uuid, data): Observable<any> {
    //return this.efoEgi.postDataCbr('/inventory/allDealer',{dealer_uuid:dealer_uuid, data:{web_crawl:{provider:provider}}})
    return this.efoEgi
      .postData('/elevate/allDealer', { dealer_uuid: dealer_uuid, data: data })
      .pipe(
        switchMap((rs) => {
          return this.efoEgi.postDataCbr('/inventory/allDealer', {
            dealer_uuid: dealer_uuid,
            data: data,
          });
        }),
      );
  }
  setVdsLookups(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/setVdsLookups', {});
  }

  findDealerInspirePostData(dealer_uuid, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 1 : limit;
    return this.efoEgi.getDataCbr('/inventory/findDealerInspirePostData', {
      dealer_uuid: dealer_uuid,
      limit,
    });
  }
  findFordDirectPostData(dealer_uuid, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 1 : limit;
    return this.efoEgi.getDataCbr('/inventory/findFordDirectPostData', {
      dealer_uuid: dealer_uuid,
      limit,
    });
  }
  getAllDealerByFacebookId(account_id): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/allDealersMem', {
        filters: { data: { facebook: { account_id } } },
        limit: 1,
      })
      .pipe(
        map((rs) => {
          return rs.length > 0 ? rs[0] : {};
        }),
      );
  }
  getAllDealerByUuid2(cbr_uuid): Observable<any> {
    return this.efoElevation.getAllDealer(cbr_uuid);
  }
  getAllDealerByGrowPodiumId(dealer_uuid): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/allDealersMem', {
        filters: { data: { growpodium: { dealer_uuid } } },
        cols: 'dealer_uuid,name,state,brands,latitude,longitude,address1,city,zip,phone,web_crawl.provider,web_crawl.new_count,web_crawl.used_count,proposal.price_sales,facebook,hubspot,edifice,growpodium',
        limit: 1,
      })
      .pipe(
        map((rs) => {
          return rs.length > 0 ? rs[0] : {};
        }),
      );
  }

  getAllDealerContacts(dealer_uuid, dealer_website): Observable<any> {
    return !dealer_uuid
      ? of([])
      : this.efoEgi
          .getDataCbr('/inventory/getAllDealerContacts', {
            dealer_uuid: dealer_uuid,
          })
          .pipe(
            map((rs) => {
              if (rs.length > 0) {
                _.each(rs[0].contacts, (d) => {
                  d.photo_url =
                    d.photo_url.indexOf('/') == 0
                      ? 'http://' + dealer_website + d.photo_url
                      : d.photo_url;
                  d.photo_url = this._sanitizer.bypassSecurityTrustResourceUrl(
                    d.photo_url,
                  );
                });
                return rs.length > 0 ? rs[0].contacts : [];
              }
            }),
          );
  }
  processCars(cars) {
    var colorMapper = {
      black: 'black',
      white: 'white',
      silver: 'silver',
      steel: 'silver',
      gray: 'gray',
      grey: 'gray',
      graphite: 'gray',
      granite: 'gray',
      red: 'red',
      blue: 'blue',
      brown: 'brown',
      orange: 'orange',
      beige: 'beige',
      cashmere: 'beige',
      sandstone: 'beige',
      ember: 'red',
      baja: 'brown',
      green: 'green',
      pine: 'green',
      almond: 'brown',
      gun: 'gray',
      yellow: 'yellow',
      gold: 'gold',
      magnetic: 'gray',
      rhino: 'blue',
      'dark amber': 'brown',
      'still night': 'blue',
      charcoal: 'gray',
      pearl: 'white',
      olive: 'green',
      ruby: 'red',
      maroon: 'red',
      titanium: 'silver',
      sangria: 'red',
      metal: 'silver',
      winter: 'white',
      billet: 'gray',
      platinum: 'silver',
      cherry: 'red',
      bronze: 'red',
      ivory: 'white',
      mango: 'orange',
      bianco: 'white',
      frostbite: 'blue',
      nickel: 'silver',
    };
    var mapperColors = _.keys(colorMapper);
    _.each(cars, (d) => {
      d.drivetrain = d.vehicle_data.drivetrain;
      d.days_in_stock = _.has(d, 'vehicle_data.inventorydate')
        ? moment().diff(
            moment(d.vehicle_data.inventorydate, 'MM/DD/YYYY'),
            'days',
          )
        : null;
      d.days_in_stock = this.efoLd.coalesce([
        d.days_in_stock,
        d.vehicle_data.days_in_stock,
        'N/A',
      ]);
      //var eColors = _.intersection(d.exterior_color.toLowerCase().split(' '),mapperColors);
      //d.exterior_short = (eColors.length==0) ? 'unknown' : colorMapper[eColors[0]];
      // var eColor = _.find(mapperColors, (c)=>{return d.exterior_color.toLowerCase().indexOf(c)>-1});
      // d.exterior_short = (_.isUndefined(eColor)) ? 'unknown' : colorMapper[eColor];
      d.exterior_short = d.exterior_color;
      // var iColor = _.find(mapperColors, (c)=>{return d.interior_color.toLowerCase().indexOf(c)>-1});
      // d.interior_short = (_.isUndefined(iColor)) ? 'unknown' : colorMapper[iColor];
      d.exterior_short = d.exterior_color;
      d.city =
        _.has(d, 'city') && !_.isNull(d.city)
          ? this.efoLd.capitalizeWords(d.city)
          : null;
      //d.transmission_short = d.transmission.toLowerCase().indexOf('manual')>-1 ? 'Manual' : 'Automatic';
      d.transmission_short = d.transmission;
      //d.carfax_url = _.has(d,'vehicle_data.carfax_url') ? d.vehicle_data.carfax_url : false;
      //d.has_carfax = !d.vehicle_data.carfax_url ? false : true;
      d.carfax_url = !_.isNull(d.carfax_url) ? d.carfax_url : false;
      d.has_carfax = _.isNull(d.carfax_url) ? false : true;
      d.carfax_one_owner = !_.isNull(d.carfax_one_owner)
        ? d.carfax_one_owner
        : false;

      d['title'] =
        _.has(d, 'vehicle_data.title') && d.vehicle_data.title != ''
          ? d.vehicle_data.title
          : (d.year + ' ' + d.make + ' ' + d.trim + ' ' + d.model).trim();
      d['description'] = _.has(d, 'vehicle_data.description')
        ? d.vehicle_data.description.replace(/\"/g, '')
        : (d.year + ' ' + d.make + ' ' + d.trim + ' ' + d.model).trim();
    });
    return cars;
  }
  getDealerCars(dealer_uuid): Observable<any> {
    return !dealer_uuid
      ? of([])
      : this.efoEgi
          .getDataCbr('/inventory/cars', { dealer_uuid: dealer_uuid })
          .pipe(
            map((rs) => {
              rs = this.processCars(rs);
              return rs;
            }),
          );
  }
  getDealerCar(dealer_uuid, vehicle_uuid): Observable<any> {
    return !dealer_uuid
      ? of([])
      : this.efoEgi
          .getDataCbr('/inventory/cars', {
            dealer_uuid: dealer_uuid,
            vehicle_uuid: vehicle_uuid,
          })
          .pipe(
            map((rs) => {
              rs = this.processCars(rs);
              return rs;
            }),
          );
  }
  getDealerCarDetails(dealer_uuid, vehicle_uuid): Observable<any> {
    //extractCarDetails
    return !dealer_uuid || !vehicle_uuid
      ? of({})
      : this.efoEgi
          .getDataCbr('/inventory/carDetails', {
            dealer_uuid: dealer_uuid,
            vehicle_uuid: vehicle_uuid,
          })
          .pipe(
            map((rs) => {
              return rs;
            }),
          );
  }

  getNewCarsNearZip(zip, options?): Observable<any> {
    return this.efoEgi
      .getDataCbr(
        '/inventory/getNewCarsNearZip',
        _.extend({ zip: zip }, options),
      )
      .pipe(
        map((rs) => {
          _.each(rs.data, (d) => {
            d['title'] =
              _.has(d, 'vehicle_data.title') && d.vehicle_data.title != ''
                ? d.vehicle_data.title
                : (d.year + ' ' + d.make + ' ' + d.trim + ' ' + d.model).trim();
            d['description'] = _.has(d, 'vehicle_data.description')
              ? d.vehicle_data.description.replace(/\"/g, '')
              : (d.year + ' ' + d.make + ' ' + d.trim + ' ' + d.model).trim();
          });
          return rs;
        }),
      );
  }
  getCarsNearZip(zip, options?): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/getCarsNearZip', _.extend({ zip: zip }, options))
      .pipe(
        map((rs) => {
          rs.data = this.processCars(rs.data);
          _.each(rs.data, (d) => {
            d['title'] =
              _.has(d, 'vehicle_data.title') && d.vehicle_data.title != ''
                ? d.vehicle_data.title
                : (d.year + ' ' + d.make + ' ' + d.trim + ' ' + d.model).trim();
            d['description'] = _.has(d, 'vehicle_data.description')
              ? d.vehicle_data.description.replace(/\"/g, '')
              : (d.year + ' ' + d.make + ' ' + d.trim + ' ' + d.model).trim();
          });
          return rs;
        }),
      );
  }
  getCntsNearZip(zip, options?): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/getCntsNearZip', _.extend({ zip: zip }, options))
      .pipe(
        map((rs) => {
          return rs;
        }),
      );
  }
  getDealersNearZip(zip, options?): Observable<any> {
    return this.efoEgi
      .getDataCbr(
        '/inventory/getDealersNearZip',
        _.extend({ zip: zip }, options),
      )
      .pipe(
        map((rs) => {
          return rs;
        }),
      );
  }
  getLookups(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getLookups', {});
  }
  getLookupsObject(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getLookupsObject', {});
  }
  updateGooglePlaceIds(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/updateGooglePlaceIds', {}).pipe(
      map((rs) => {
        return rs;
      }),
    );
  }
  updateGooglePlaceInfo(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/updateGooglePlaceInfo', {}).pipe(
      map((rs) => {
        return rs;
      }),
    );
  }
  requestGoogleUsedCarDealers(zip): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/requestGoogleUsedCarDealers', { zip: zip })
      .pipe(
        map((rs) => {
          return rs;
        }),
      );
  }
  getGoogleUsedCarDealersNearZip(zip): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/getGoogleUsedCarDealersNearZip', { zip: zip })
      .pipe(
        map((rs) => {
          return rs;
        }),
      );
  }
  loadGoogleUsedCarDealersNearZip(zip): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/loadGoogleUsedCarDealersNearZip', { zip: zip })
      .pipe(
        map((rs) => {
          return rs;
        }),
      );
  }
  moveGoogleUsedDealersToAllDealers(): Observable<any> {
    return this.efoEgi
      .getDataCbr('/inventory/moveGoogleUsedDealersToAllDealers', {})
      .pipe(
        map((rs) => {
          return rs;
        }),
      );
  }

  getGoogleInfo(dealer_uuid, refresh?): Observable<any> {
    return !dealer_uuid
      ? of({})
      : //this.efoEgi.getDataCbr('/inventory/googleInfo', {dealer_uuid: dealer_uuid,refresh:refresh},).pipe(map(rs => {
        this.efoElevation.getGoogleDealerInfo(dealer_uuid).pipe(
          map((rs: any) => {
            var result = {
              googleResult: <any>{},
              googleRating: 'N/A',
              googleTotalUserRatings: 'N/A',
              dealerPhotoUrl: null,
            };
            if (!_.isEmpty(rs.google_info)) {
              result.googleResult = rs.google_info;
              // @ts-ignore
              result.googleRating = result.googleResult.rating;
              // @ts-ignore
              result.googleTotalUserRatings =
                result.googleResult.user_ratings_total;
              // @ts-ignore
              if (
                _.has(result, 'googleResult.photos') &&
                result.googleResult.photos.length > 0
              ) {
                let photo = _.find(result.googleResult.photos, (d) => {
                  return d.width > d.height;
                });
                photo = photo ?? result.googleResult.photos[0];
                result.dealerPhotoUrl =
                  'https://maps.googleapis.com/maps/api/place/photo?photoreference=' +
                  photo.photo_reference +
                  '&sensor=false&maxheight=240&maxwidth=640&key=AIzaSyAzRlpb4MbISc_8JRIF8TIqgsrQEjOdv14';
              }
            } else {
              result.googleRating = 'N/A';
              result.googleTotalUserRatings = 'N/A';
            }
            return result;
          }),
        );
  }

  queueInventoryExtraction(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/cbrmon/queueInventoryExtraction', {
      dealers,
      limit,
    });
  }
  queueCbrInventoryExtraction(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/cbrmon/queueCbrInventoryExtraction', {
      dealers,
      limit,
    });
  }
  moveDealerInventory(): Observable<any> {
    return this.efoEgi.getDataCbr('/cbrmon/moveDealerInventory', {});
  }
  queueInventoryExtractionByLocation(zip, distance?): Observable<any> {
    distance = _.isUndefined(distance) ? 20 : distance;
    return this.efoEgi.getDataCbr('/cbrmon/queueInventoryExtraction', {
      zip: zip,
      distance,
    });
  }
  queueInventoryExtractionAll(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 2000 : limit;
    return this.efoEgi.getDataCbr('/cbrmon/queueInventoryExtraction', {
      limit,
    });
  }
  queueCbrInventoryExtractionAll(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 2000 : limit;
    return this.efoEgi.getDataCbr('/cbrmon/queueCbrInventoryExtraction', {
      limit,
    });
  }

  moveCarsTmpToCars(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/moveCarsTmpToCars', {});
  }
  moveShadowToProd(): Observable<any> {
    return this.efoEgi.getDataCbr('/cbrmon/moveShadowToProd', {});
  }

  clearCarsTmpQueue(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/clearCarsTmpQueue', {});
  }
  pauseInventoryExtraction(): Observable<any> {
    return this.efoEgi.getDataCbr('/cbrmon/pauseInventoryExtraction', {});
  }
  unpauseInventoryExtraction(): Observable<any> {
    return this.efoEgi.getDataCbr('/cbrmon/unpauseInventoryExtraction', {});
  }
  toggleExtraction(): Observable<any> {
    return this.efoEgi.getDataCbr('/cbrmon/toggleExtraction', {});
  }
  getQueues(): Observable<any> {
    return this.efoEgi.getDataCbr('/cbrmon/getQueues', {});
  }

  queueProviderExtraction(dealer_uuids, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.post('/inventory/queueProviderExtraction', {
      dealer_uuids,
      limit,
    });
  }
  queueCbrProviderExtraction(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/queueCbrProviderExtraction', {
      dealers,
      limit,
    });
  }
  queueCbrFindRedirects(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/queueCbrFindRedirects', {
      dealers,
      limit,
    });
  }
  queueProviderExtractionKnownBad(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/queueProviderExtraction', {
      limit,
    });
  }

  fetchDealers2021ByApi(website): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/fetchDealers2021ByApi', {
      website,
    });
  }
  fetchFoxDealerByApi(website): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/fetchFoxDealerByApi', {
      website,
    });
  }
  fetchCarsForSaleByApi(website): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/fetchCarsForSaleByApi', {
      website,
    });
  }
  fetchDealerInspire2020(website): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/fetchDealerInspire2020', {
      website,
    });
  }
  fetchDealerInspire2020ByIndexName(dealer_uuid): Observable<any> {
    return this.getAllDealers({
      dealer_uuid: dealer_uuid,
      cols: 'dealer_uuid,name,website,web_crawl,zip',
      limit: 1,
    }).pipe(
      switchMap((rs) => {
        var d = rs.data[0];
        return this.efoEgi.getDataCbr(
          '/inventory/fetchDealerInspire2020ByIndexName',
          {
            website: d.website,
            dealer_inspire: d.data.web_crawl.dealer_inspire,
            zip: d.data.zip,
          },
        );
      }),
    );
  }

  populateDealers2021AccountIdTable(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr(
      '/inventory/populateDealers2021AccountIdTable',
      { limit },
    );
  }
  populateDealers2021AccountsTable(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr(
      '/inventory/populateDealers2021AccountsTable',
      { limit },
    );
  }
  getDealerInspire2020ApiIdsLocations(dealer_uuid): Observable<any> {
    return this.efoEgi.getDataCbr(
      '/inventory/getDealerInspire2020ApiIdsLocations',
      { dealer_uuid: dealer_uuid },
    );
  }
  queueDealerInspireApiIdsLocationsExtraction(
    dealers,
    limit?,
  ): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr(
      '/inventory/queueDealerInspireApiIdsLocationsExtraction',
      { dealer_uuid: dealers, limit },
    );
  }
  queueDealeronDealershipExtraction(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr(
      '/inventory/queueDealeronDealershipExtraction',
      { dealer_uuid: dealers, limit },
    );
  }
  queueCdkLocationsExtraction(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/queueCdkLocationsExtraction', {
      dealer_uuid: dealers,
      limit,
    });
  }
  queueDealerInspireLocationsExtraction(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr(
      '/inventory/queueDealerInspireLocationsExtraction',
      { dealer_uuid: dealers, limit },
    );
  }

  populateDealerInspire2020ApiIdTable(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr(
      '/inventory/populateDealerInspire2020ApiIdTable',
      { limit },
    );
  }
  autoSetDealers2021AccountId(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/autoSetDealers2021AccountId', {
      limit,
    });
  }
  autoSetDealers2021AccountIdByDealerUuid(
    dealer_uuids: any[],
  ): Observable<any> {
    return this.efoEgi.getDataCbr(
      '/inventory/autoSetDealers2021AccountIdByDealerUuid',
      { dealer_uuid: dealer_uuids },
    );
  }
  autoSetDealerInspire2020ApiId(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/autoSetDealerInspire2020ApiId', {
      limit,
    });
  }
  autoSetDealerInspire2020ApiIdNewCarsOnly(limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr(
      '/inventory/autoSetDealerInspire2020ApiIdNewCarsOnly',
      { limit },
    );
  }
  getDealers2021MissingAccountIds(): Observable<any> {
    return this.efoEgi.getDataCbr(
      '/inventory/getDealers2021MissingAccountIds',
      {},
    );
  }
  setDealers2021AccountId(dealer_uuid, account_id): Observable<any> {
    return this.efoEgi.postDataCbr('/inventory/setDealers2021AccountId', {
      dealer_uuid: dealer_uuid,
      account_id: account_id,
    });
  }
  getDealerInspire2020MissingApiIds(): Observable<any> {
    return this.efoEgi.getDataCbr(
      '/inventory/getDealerInspire2020MissingApiIds',
      {},
    );
  }
  getDealeronMissingLocations(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getDealeronMissingLocations', {});
  }
  getCdkMissingLocations(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getCdkMissingLocations', {});
  }
  getDealerInspireApiIdDetails(dealer_uuid): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getDealerInspireApiIdDetails', {
      dealer_uuid: dealer_uuid,
    });
  }
  getDealerInspireApiIdCars(dealer_uuid, api_id): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getDealerInspireApiIdCars', {
      dealer_uuid: dealer_uuid,
      api_id: api_id,
    });
  }
  setDealerInspire2020ApiId(dealer_uuid, api_id): Observable<any> {
    return this.efoEgi.postDataCbr('/inventory/setDealerInspire2020ApiId', {
      dealer_uuid: dealer_uuid,
      api_id: api_id,
    });
  }
  setDealerInspire2020FacetFilters(
    dealer_uuid,
    facet_filters,
  ): Observable<any> {
    return this.efoEgi.postDataCbr(
      '/inventory/setDealerInspire2020FacetFilters',
      { dealer_uuid: dealer_uuid, facet_filters: facet_filters },
    );
  }

  setDealeronLocation(dealer_uuid, location): Observable<any> {
    return this.efoEgi.postDataCbr('/inventory/setDealeronLocation', {
      dealer_uuid: dealer_uuid,
      location: location,
    });
  }
  setCdkLocation(dealer_uuid, location): Observable<any> {
    return this.efoEgi.postDataCbr('/inventory/setCdkLocation', {
      dealer_uuid: dealer_uuid,
      location: location,
    });
  }

  extractAllDealerContacts(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/extractAllDealerContacts', {
      dealer_uuid: dealers,
      limit,
    });
  }
  extractCbrDealerContacts(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/extractCbrDealerContacts', {
      dealer_uuid: dealers,
      limit,
    });
  }
  extractAllDealerInventory(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/extractAllDealerInventory', {
      dealer_uuid: dealers,
      limit,
    });
  }
  extractDealerInventoryJson(dealer_uuid): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/extractDealerInventoryJson', {
      dealer_uuid: dealer_uuid,
    });
  }

  findDealerWebProvider(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/findDealerWebProvider', {
      dealer_uuid: dealers,
      limit,
    });
  }
  findProvider(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/findProvider', {
      dealer_uuid: dealers,
      limit,
    });
  }

  findDealersComVersion(dealers, limit?): Observable<any> {
    limit = _.isUndefined(limit) ? 10 : limit;
    return this.efoEgi.getDataCbr('/inventory/findDealersComVersion', {
      dealer_uuid: dealers,
      limit,
    });
  }
  reloadDealers2MemDb(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/reloadDealers2MemDb', {});
  }

  getHtmlElevate(url, selector?): Observable<any> {
    selector = _.isUndefined(selector) ? 'body' : selector;
    return this.efoEgi.getDataCbr('/inventory/getHtml', {
      url: url,
      selector: selector,
    });
  }
  getHtml(url, selector?): Observable<any> {
    selector = _.isUndefined(selector) ? 'body' : selector;
    return this.efoEgi.getDataCbr('/inventory/getHtml', {
      url: url,
      selector: selector,
    });
  }
  getHtmlCf(url, selector?): Observable<any> {
    selector = _.isUndefined(selector) ? 'body' : selector;
    return this.efoEgi.getDataCbr('/inventory/getHtmlCf', {
      url: url,
      selector: selector,
    });
  }
  getHtmlProxy(url, selector?): Observable<any> {
    selector = _.isUndefined(selector) ? 'body' : selector;
    return this.efoEgi.getDataCbr('/inventory/getHtmlProxy', {
      url: url,
      selector: selector,
    });
  }
  getHtmlPhantom(url, selector?): Observable<any> {
    selector = _.isUndefined(selector) ? 'body' : selector;
    return this.efoEgi.getDataCbr('/inventory/getHtmlPhantom', {
      url: url,
      selector: selector,
    });
  }
  vehicleExtractors(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/vehicleExtractors', {});
  }

  brandMarketShare(): Observable<any> {
    return this.efoElevation.getBrandMarketShare();
  }

  getExtractorCountByBrand(brand): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getExtractorCountByBrand', {
      brand: brand,
    });
  }
  testWebParser(html, extract_func): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/testWebParser', {
      html: html,
      extract_func: extract_func,
    });
  }
  saveFacebookVehicleCatalog(cbr_uuid): Observable<any> {
    return this.get('/inventory/saveFacebookCatalog', {
      cbr_uuid,
    });
  }
  updateCustomerCatalog(account_num): Observable<any> {
    return this.get('/inventory/updateCustomerCatalog', {
      account_num,
    });
  }
  refreshCatalogData(catalog_id): Observable<any> {
    return this.get('/inventory/requestProductFeedUpdate', {
      catalog_id,
    });
  }
  updateCustomerCatalogs(): Observable<any> {
    return this.get('/inventory/updateCustomerCatalogs');
  }
  getFacebookVehicleCatalog(dealer_uuid): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getFacebookVehicleCatalog', {
      dealer_uuid,
    });
  }

  getAllDealersByZip(zip, distance = 30, limit = 1000): Observable<any> {
    var options = {
      zip,
      distance,
      limit,
    };
    //foreturn this.efoEgi.getDataCbr('/inventory/getAllDealersByZip',options)
    return this.efoElevation.getAllDealersByZip(options);
  }
  getAllDealersByZipBrands(
    zip,
    brands: String[],
    distance = 30,
    limit = 1000,
  ): Observable<any> {
    var options = {
      zip,
      brands,
      distance: 30,
      limit: 1000,
    };
    //return this.efoEgi.getDataCbr('/inventory/getAllDealersByZip',options)
    return this.efoElevation.getAllDealersByZip(options);
  }
  refreshDealerFbCatalog(options): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/refreshDealerFbCatalog', options);
  }
  refreshDealerInventory(options): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/refreshDealerInventory', options);
  }

  public socketListen = () => {
    if (_.isUndefined(this.socket)) {
      this.socket = io(this.socketUrl, {
        transports: ['websocket'],
      });
      this.socket.on('connect', () => {
        this.socket.emit(
          'new-message',
          'portal service connected: cbr.service',
        );
      });
    }
    return new Observable((observer) => {
      this.socket.on('inventory', (data) => {
        observer.next(data);
      });
    });
  };
  //Function to update local array values
  upsert(arr, key, newval, omitKeys): void {
    var match = _.find(arr, key);
    // var match2 = _.findIndex(arr, key);
    if (match) {
      //var index = _.indexOf(arr, _.find(arr, key));
      var index = _.indexOf(arr, match);
      var oDiff = _.reduce(
        newval,
        function (o, d, k) {
          if (_.isUndefined(match[k]) || match[k] !== d) {
            o[k] = { old_val: match[k], new_val: d };
          }
          return o;
        },
        _.extend({}, key),
      );
      if (_.keys(_.omit(oDiff, omitKeys)).length > 0) {
        arr.splice(index, 1, newval);
      }
    } else {
      arr.unshift(newval);
    }
  }

  updateAllDealersAssessment(dealer_uuid, data): Observable<any> {
    return this.efoEgi.putDataCbr(
      '/inventory/allDealersAssessment/' + dealer_uuid,
      data,
    );
  }

  //Reports Stuff
  getReports(params?): Observable<any> {
    var params = _.extend({}, params);
    return this.efoEgi.getDataCbr('/inventory/getReports', params);
  }
  getReport(report_uuid): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getReports', {
      report_uuid: report_uuid,
    });
  }
  getReportData(report_uuid): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/getReportData', {
      report_uuid: report_uuid,
    });
  }
  getReportDataMakeModel(): Observable<any> {
    return this.getReportData('ea2e75b6-9c96-4cd7-8f2c-e8cfceacc318').pipe(
      tap((rs) => {
        _.each(rs, (d) => {
          d.cnt = +d.cnt;
          d.vin_cnt = +d.vin_cnt;
        });
      }),
    );
  }
  getReportDataContactCounts(): Observable<any> {
    return this.getReportData('51409a69-95d1-41c2-bca2-4b23313a223a').pipe(
      tap((rs) => {
        _.each(rs, (d) => {
          d.dealer_cnt = +d.dealer_cnt;
          d.vin_cnt = +d.vin_cnt;
        });
      }),
    );
  }

  getReportDataExtractionProblems(): Observable<any> {
    return this.getReportData('b489c362-a0c5-4fcc-8ed7-22fdda4694f3').pipe(
      tap((rs) => {
        _.each(rs, (d) => {
          d.cnt = +d.cnt;
        });
      }),
    );
  }
  getReportDataInventoryCounts(): Observable<any> {
    return this.getReportData('393c39a2-500e-4ed8-a75d-b5a06a5c17d5').pipe(
      tap((rs) => {
        _.each(rs, (d) => {
          d.dealer_cnt = +d.dealer_cnt;
          d.car_cnt = +d.car_cnt;
          d.vin_cnt = +d.vin_cnt;
        });
      }),
    );
  }
  getReportDataAllDealerCount(): Observable<any> {
    return this.getReportData('35988559-2619-42e6-8a53-2d29be005ccf').pipe(
      tap((rs) => {
        _.each(rs, (d) => {
          d.cnt = +d.cnt;
        });
      }),
    );
  }
  refreshReportData(report_uuid, params?): Observable<any> {
    var myParams = _.extend({ report_uuid: report_uuid }, params);
    return this.efoEgi.getDataCbr(
      '/inventory/refreshReportData',
      _.extend({ report_uuid: report_uuid }, params),
    );
  }
  upsertReport(report_uuid, data): Observable<any> {
    return this.efoEgi.postDataCbr('/inventory/report', {
      report_uuid: report_uuid,
      data: data,
    });
  }
  deleteReport(report_uuid, data): Observable<any> {
    return this.efoEgi.deleteDataCbr('/inventory/report', {
      report_uuid: report_uuid,
    });
  }

  //Kpis
  kpiExtractionAgeByMinute(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/kpiExtractionAgeByMinute', {});
  }
  kpiExtractionAgeByHour(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/kpiExtractionAgeByHour', {});
  }
  kpiBadExtractionByProvider(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/kpiBadExtractionByProvider', {});
  }
  kpiBadExtractionsList(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/kpiBadExtractionsList', {});
  }
  kpiCarTmpCounts(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/kpiCarTmpCounts', {});
  }

  getDealerDuplicates(): Observable<any> {
    return this.efoEgi.getDataCbr('/inventory/dealerDuplicates', {});
  }

  deleteDealer(dealer_uuid): Observable<any> {
    return this.efoEgi.deleteDataCbr('/inventory/dealer', {
      dealer_uuid: dealer_uuid,
    });
  }
}
